import { useSearchParams } from "react-router-dom";
import { AwsIntegrationServerlessPage } from "./AwsIntegrationServerlessPage/AwsIntegrationServerlessPage";
import { AwsIntegrationHostedPage } from "./AwsIntegrationHostedPage/AwsIntegrationHostedPage";
import { INTEGRATION_MRN } from "~/pages/integrations/utils/integrationConstants";
import { OrganizationScope, SpaceScope } from "~/hooks/useScope";

export interface AwsIntegrationPageProps {
  scope: SpaceScope | OrganizationScope;
}

export function AwsIntegrationPage({ scope }: AwsIntegrationPageProps) {
  const [searchParams] = useSearchParams();
  const integrationMrn = searchParams.get(INTEGRATION_MRN);
  const isServerless = !integrationMrn || integrationMrn.includes("aws");

  return isServerless ? (
    <AwsIntegrationServerlessPage scope={scope} />
  ) : (
    <AwsIntegrationHostedPage scope={scope} />
  );
}
